<template>
    <v-tab-item>
        <v-skeleton-loader v-if="! enrollments" type="table-body"></v-skeleton-loader>

        <div v-else>
            <date-range-selector v-model="dateRange"></date-range-selector>

            <proof-downloader :dateRange="dateRange" class="ml-4"></proof-downloader>

            <user-table :enrollments="enrollments" class="mt-4"></user-table>
        </div>
    </v-tab-item>
</template>

<script>
import DateRangeSelector from './DateRangeSelector'
import moment from '@/plugins/moment'
import ProofDownloader from './ProofDownloader'
import UserTable from './UserTable'

export default {
    components: {
        DateRangeSelector,
        ProofDownloader,
        UserTable,
    },

    data() {
        return {
            enrollments: null,
            dateRange: [
                moment().subtract(1, 'months').format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD'),
            ],
        }
    },

    watch: {
        dateRange(to) {
            if (to.length === 2) {
                this.getUserList()
            }
        }
    },

    methods: {
        getUserList() {
            this.$api.get(`period/${this.$route.params.period_id}/paidUser`, {
                loader: 'appbar',
                params: {
                    fromDate: this.dateRange[0],
                    toDate: this.dateRange[1],
                }
            })
                .then(response => {
                    this.enrollments = response.data.enrollments
                })
        }
    },

    created() {
        this.getUserList()
    }
}
</script>
